export function generateEvaluatorDocId(evaluatorId: string, userId: string): string {
  return `evaluator_${evaluatorId}_${userId}`;
}

export function parseEvaluatorDocId(docId: string): { evaluatorId: string; userId: string } | null {
  const parts = docId.split('_');
  if (parts.length !== 3 || parts[0] !== 'evaluator') {
    return null;
  }

  return {
    evaluatorId: parts[1],
    userId: parts[2]
  };
}